import { Permission } from "../../apis/mgmt/api";
import { DataFormWithButtonsLayout } from "../common/DataFormWithButtonsLayout";
import { EditableProps } from "../common/Editable";
import { PermissionForm } from "./PermissionForm";


export const PermissionEditable = function (
    props: EditableProps<Permission>
) {

    return (
        <DataFormWithButtonsLayout editableProps={props}>
            <PermissionForm {...props} />
        </DataFormWithButtonsLayout>
    );

};
